import React, { useEffect, useState } from 'react';
import { Row, Col, Typography, Tabs, Button, Divider } from 'antd';
// import './List.css';
import Car from './Car';
// import styles from './styles.module.less';
import ProfileData from './ProfileData';
import NewMatch from './NewMatch';
// import Visitors from './Visitors';
import Requested from './Requested';
import Liked from './Liked';
import AIData from './AIList/';

import styles from './index.module.less';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;
const { TabPane } = Tabs;

// import circle from "../assets/circles.png"

const List = ({
  user_data,
  list_data,
  activeTab,
  setActiveTab,
  list_pagination,
  handlegetAIData,
  list_AIdata,
  aiacceptedLoading,
  onSubmit,
  onProfileAction,
  tabActive,
  user_payment_data
}) => {
  const navigate = useNavigate();
  // const [activeTab, setActiveTab] = useState('1');
  // console.log('tabActive', tabActive);
  console.log('user_data', user_data);

  useEffect(() => {
    document.title = 'Matrimony dashboard - Find compatible matches';
  }, []);

  // Set pagination from backend response
  // State for local pagination
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = list_pagination?.page_size || 6;

  const TABS = [
    { id: '1', label: 'ALL' },
    { id: '2', label: 'NEW' },
    // { id: '3', label: 'Visitors' },
    { id: '3', label: 'REQUESTS' },
    { id: '4', label: 'FAVORITES' },
    { id: '5', label: 'SMART MATCH' }
  ];

  const paginatedData = list_data?.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  // Update local state when backend pagination changes
  useEffect(() => {
    setCurrentPage(list_pagination?.current_page || 1);
  }, [list_pagination]);

  // console.log('list_data.length', list_data);

  //tab content
  const renderedTabContent = () => {
    switch (activeTab) {
      case '1':
        return (
          <ProfileData
            list_data={list_data}
            paginatedData={paginatedData}
            currentPage={currentPage}
            pageSize={pageSize}
            // totalItems={list_pagination?.total_items}
            // totalItems={list_pagination?.total_records || list_data.length}
            totalItems={list_pagination?.total_records || 9}
            handlePageChange={handlePageChange}
            onProfileAction={onProfileAction}
          />
        );
      case '2':
        return (
          <NewMatch list_data={list_data} onProfileAction={onProfileAction} />
        );
      case '3':
        // return <Visitors />;
        return (
          <Requested
            list_data={list_data}
            onProfileAction={onProfileAction}
            handlePageChange={handlePageChange}
            tabActive={tabActive}
          />
        );
      case '4':
        return (
          <Liked
            list_data={list_data}
            onProfileAction={onProfileAction}
            paginatedData={paginatedData}
            currentPage={currentPage}
            pageSize={pageSize}
            // totalItems={list_pagination?.total_items}
            // totalItems={list_pagination?.total_records || list_data.length}
            totalItems={list_pagination?.total_records || 9}
            handlePageChange={handlePageChange}
            tabActive={tabActive}
          />
        );
      case '5':
        return (
          <AIData
            handlegetAIData={handlegetAIData}
            list_AIdata={list_AIdata}
            list_data={list_data}
            aiacceptedLoading={aiacceptedLoading}
            onSubmit={onSubmit}
            onProfileAction={onProfileAction}
          />
        );

      default:
        return null;
    }
  };

  // console.log('Active list_pagination', list_pagination);

  // Handle page change: Call backend when user navigates to a new page
  const handlePageChange = (page) => {
    setCurrentPage(page);
    // fetchData(page); // Fetch new data from API based on page number
  };

  const handlecreatepage = () => {
    navigate('/editprofile');
  };

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  // const name = matUserObject.user_details.email;
  // const customerName =
  //   matUserObject.user_details.first_name +
  //   ' ' +
  //   matUserObject.user_details.last_name;
  const customerName = matUserObject.user_details.first_name;

  return (
    <div className={styles.maincontainer}>
      {/* Main Row */}
      <Row align="middle" gutter={[24, 32]} className={styles.hero}>
        {/* Left side */}
        <Col xl={7} lg={9} md={24} sm={24} className={styles.heroCol}>
          <Title level={1} className={styles.heroTitle}>
            {/* Welcome Sanjana!  */}
            Welcome
            <h1 className={styles.heroTitle}>{customerName}</h1>
          </Title>
          <Title level={2} className={styles.heroTitle2}>
            <p>Are you ready to </p>
            <p>meet your Life Partner!</p>{' '}
            {/* Before offer We can enable the code */}
            <div className={styles.completebutton}>
              <Button className={styles.outlinebtn} onClick={handlecreatepage}>
                Complete your profile
              </Button>
            </div>
            {/* Before offer We can enable the code */}
          </Title>
        </Col>

        {/* Carousel */}
        <Col xl={17} lg={15} md={24} sm={24} style={{ width: '100%' }}>
          <Car />
        </Col>
      </Row>

      {/* Tabs Section */}
      <div className={styles.tab}>
        {/* {user_data?.is_subscribed ? ( */}
        {user_payment_data ? (
          <Tabs
            activeKey={activeTab}
            // onChange={(key) => setActiveTab(key)}
            onChange={(key) => {
              setActiveTab(key);
              setCurrentPage(1); // Reset to page 1 on tab change
            }}
            tabBarStyle={{
              borderBottom: '1px solid #d20b0b',
              padding: '0rem 1rem'
            }}
          >
            {TABS.map((tab) => (
              <TabPane
                tab={<Text className="tabText">{tab.label}</Text>}
                key={tab.id}
              ></TabPane>
            ))}
          </Tabs>
        ) : (
          <>
            <Divider className={styles.dividerline}></Divider>
            <div className={styles.alldetails}>
              <h5>A few more details and —</h5>
              <h1>that’s how soul connections happen!</h1>
              <div className={styles.completebutton}>
                <Button
                  className={styles.outlinebtn}
                  onClick={handlecreatepage}
                >
                  Complete your profile
                </Button>
              </div>
            </div>
            <br />
            <br />
          </>
        )}
      </div>
      {/* {renderedTabContent()} */}
      {/* {user_data?.is_subscribed && renderedTabContent()} */}
      {user_payment_data && renderedTabContent()}
      {/* <ProfileData/> */}
    </div>
  );
};

export default List;
